import type { TemplateFolder } from '~/types/template-folder'
import type { BusinessCampaignTemplatePayload } from '~/types/business-campaign-template'

export function useWorkSpace() {
  const getWorkSpace = async () => {
    const res = await $fetch<unknown>(`/api/v1/work-space`)
    return res
  }

  const updateWorkSpace = async (body: { id: string } & Record<string, unknown>) => {
    const res = await $fetch(`/api/v1/work-space/${body.id}`, {
      method: 'PUT',
      body: body,
    })
    return res
  }

  const updateWorkspaceEmailCompliance = async (body: {
    emailComplianceLegalName: string | null
    emailCompliancePostalAddress: Record<string, string> | null
    emailComplianceContactEmail: string | null
    emailComplianceContactPhone: string | null
    emailComplianceNumber: string | null
    emailComplianceBusinessTaxId: string | null
  }) => {
    const res = await $fetch(`/api/v1/work-space/email-compliance`, {
      method: 'PUT',
      body,
    })
    return res
  }

  const updateTheme = async (theme: string) => {
    const res = await $fetch(`/api/v1/work-space/theme`, {
      method: 'PUT',
      body: {
        theme,
      },
    })
    return res
  }

  const getTheme = async () => {
    const res = await $fetch<unknown>(`/api/v1/work-space/theme`)
    return res
  }

  const createWorkSpace = async (body: any) => {
    const res = await $fetch(`/api/v1/work-space`, {
      method: 'POST',
      body: body,
    })
    return res
  }

  const getAllWorkSpaces = async () => {
    const res = await $fetch(`/api/v1/work-space/get-all`, {
      method: 'GET',
    })
    return res
  }

  const setActiveWorkSpace = async (body: any) => {
    const res = await $fetch(`/api/v1/work-space/set-active`, {
      method: 'POST',
      body: body,
    })
    const { getThemeFromDBAndApply } = useThemeUtils()
    await getThemeFromDBAndApply()
    return res
  }

  const getUserInvites = async () => {
    const res = await $fetch(`/api/v1/work-space/invites`, {
      method: 'GET',
    })
    return res
  }

  const acceptInvite = async (body: any) => {
    const res = await $fetch(`/api/v1/work-space/invites/accept`, {
      method: 'POST',
      body: body,
    })
    return res
  }

  const getTemplateFolders = async () => {
    const res = await $fetch(`/api/v1/work-space/template-folders`, {
      method: 'GET',
    })

    const {sortByNumberName} = useUtils()
    const newData = sortByNumberName(res?.data, 'name')
    res.data = newData
    return res
  }

  const updateTemplateFolders = async (templateFolders: TemplateFolder[]) => {
    const res = await $fetch(`/api/v1/work-space/template-folders`, {
      method: 'PUT',
      body: {
        templateFolders,
      },
    })
    return res
  }

  const getContactProfileSchema = async() => {
     const res = await $fetch(`/api/v1/work-space/get-contact-profile-schema`, {
      method: 'GET'
    })
    return res
  }

  const updateContactProfileSchema = async(newSchema: object) => {
    const res = await $fetch(`/api/v1/work-space/update-contact-profile-schema`, {
      method: 'PUT',
      body: { newSchema },
    })
    return res
  }

  const saveBusinessCampaignTemplate = async (payload: BusinessCampaignTemplatePayload) => {
    const res = await $fetch(`/api/v1/work-space/business-campaign-template`, {
      method: 'PUT',
      body: payload,
    })
    return res
  }

  return {
    getWorkSpace,
    updateWorkSpace,
    updateWorkspaceEmailCompliance,
    updateTheme,
    getTheme,
    createWorkSpace,
    getAllWorkSpaces,
    setActiveWorkSpace,
    getUserInvites,
    acceptInvite,
    getTemplateFolders,
    updateTemplateFolders,
    getContactProfileSchema,
    updateContactProfileSchema,
    saveBusinessCampaignTemplate,
  }
}
